import { REDUX_WORKFLOW_SEARCH, REDUX_WORKFLOW_FILTERS } from './shared/constants/localstorage.constants';
import { hotSpotModalInitialState } from './domain/dashboard/hotspot/hot-spot-modal/hot-spot-modal.state';


const reduxWorkflowFilters = JSON.parse(localStorage.getItem(REDUX_WORKFLOW_FILTERS));
const reduxWorkflowSearch = JSON.parse(localStorage.getItem(REDUX_WORKFLOW_SEARCH));

const workflowState = {
    columns: {},
    excludedCards: [],
    loggedUser: {},
    cardsWithError: [],

    totalToComplete: {
        budgetShareTotal: 0,
        decreaseTotal: 0,
        increaseTotal: 0,
    },
    totalMetricsSum: {
        totalConversions: 0,
        totalCost: 0,
        totalImpressions: 0,
    },
    totalMetricsPercentageOfTotal: {
        newUserConversions: 0,
        newUserCost: 0,
        newUserImpressions: 0,
    },
    filters: reduxWorkflowFilters || {},
    search: reduxWorkflowSearch || '',
};

const dataState = {
    objectSelected: {
        account_selected: {
            id: '',
        },
        client_selected: {},
        loadingObjectSelected: true,
    },
};

const settingsState = {
    accountAssociationModal: {
        isAccountAssociationModalOpen: false,
    },
};

const dashboardState = {
    hotSpotModal: {
        ...hotSpotModalInitialState,
    },
    budgetManager: {
        isBudgetManagerModalOpen: false,
        loadState: false,
    },
};

const initialState = {
    data: dataState,
    workflow: workflowState,
    settings: settingsState,
    dashboard: dashboardState,
};

export default initialState;
